import { render, staticRenderFns } from "./SearchOrCreateModel.vue?vue&type=template&id=2bba4b3a&"
import script from "./SearchOrCreateModel.vue?vue&type=script&lang=js&"
export * from "./SearchOrCreateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports